<template>
  <div>
    <div @click="clickMe">点击触发</div>
  </div>
</template>
<script>
  export default {
    data(){
      return{
        dataList:null
      }
    },
    methods:{
      clickMe(){
        let self=this //这里定义一个self指向外部整体的js
        // axios.post('http://116.62.106.130:8085/hn/gateway.htm',逗号后面可以传参)
        axios.post('/hn/gateway.htm')
          .then(function (res) {
            //正确回调

            console.log(res)
            self.dataList=res.data.rst//这里用self去给data里面的变量赋值
          })
          .catch(function (res) {
            //错误回调
          })
      }
    },
    mounted(){

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/enrollingMsg.vue